<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { navigate } from 'svelte-routing';
  import AlertTriangle from 'lucide-svelte/icons/alert-triangle';
  import RefreshCw from 'lucide-svelte/icons/refresh-cw';
  import Home from 'lucide-svelte/icons/home';
  import { Button } from '../lib/components/ui/index';

  /** Optional error message passed via state */
  export let errorMessage: string | null = null;
</script>

<div class="flex flex-col items-center justify-center py-20 px-4 text-center">
  <div class="mb-6 p-6 bg-error/10 rounded-full">
    <AlertTriangle class="w-16 h-16 text-error" strokeWidth={1.5} />
  </div>

  <h1 class="text-3xl font-semibold text-text mb-2">
    {$_('pages.error.server_error_title')}
  </h1>

  <p class="text-text-secondary mb-4 max-w-md mx-auto">
    {$_('pages.error.server_error_message')}
  </p>

  {#if errorMessage}
    <div
      class="bg-bg-alt border border-border p-3 rounded-lg mb-8 font-mono text-xs text-text-muted break-all max-w-lg"
    >
      {errorMessage}
    </div>
  {/if}

  <div class="flex gap-3">
    <Button variant="primary" on:click={() => window.location.reload()}>
      <RefreshCw class="w-4 h-4" strokeWidth={1.5} />
      {$_('pages.error.retry')}
    </Button>
    <Button variant="secondary" on:click={() => navigate('/')}>
      <Home class="w-4 h-4" strokeWidth={1.5} />
      {$_('nav.dashboard')}
    </Button>
  </div>
</div>
